export const foldForMatching = (value: string): string =>
    value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Where the query appears in the text, ignoring case and accents, as [start, end) ranges of the original text. Each
// character is folded on its own so a match in the folded text maps back to the characters it came from.
export const findMatchRanges = (text: string, query: string): [number, number][] => {
    const foldedQuery = foldForMatching(query);
    if (foldedQuery === "") {
        return [];
    }

    let folded = "";
    const starts: number[] = [];
    const ends: number[] = [];
    let index = 0;
    for (const char of text) {
        const foldedChar = foldForMatching(char);
        folded += foldedChar;
        // One entry per UTF-16 unit, the unit indexOf counts in, so a surrogate pair maps back whole.
        for (let unit = 0; unit < foldedChar.length; unit++) {
            starts.push(index);
            ends.push(index + char.length);
        }
        index += char.length;
    }

    const ranges: [number, number][] = [];
    let hit = folded.indexOf(foldedQuery);
    while (hit !== -1) {
        const start = starts[hit];
        const end = ends[hit + foldedQuery.length - 1];
        const last = ranges.at(-1);
        if (last && last[1] >= start) {
            last[1] = Math.max(last[1], end);
        } else {
            ranges.push([start, end]);
        }
        hit = folded.indexOf(foldedQuery, hit + foldedQuery.length);
    }

    return ranges;
};
